import { createSelector } from 'reselect'
import { RootState } from '../types'

export const historySelector = (state: RootState): RootState['history'] => {
  return state.history
}

export const historyItemsSelector = createSelector(historySelector, (state) => {
  return state.data.items
})

export const historyMetaSelector = createSelector(historySelector, (state) => {
  return state.data.meta
})

export const historyFiltersSelector = createSelector(historySelector, (state) => {
  return state.filters
})

export const historyLoadingStateSelector = (state: RootState): RootState['history']['status'] => state.history.status

export const historyIsLoadingSelector = createSelector(
  historyLoadingStateSelector,
  (state): boolean => state === 'LOADING',
)
